import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { QuizzesSpinner as Spinner } from '../shared/spinner/Spinner';
import { Card } from '../shared/Card';
import { RceConfigContext } from '@instructure/quiz-common';
import { hasAllPropsForRcs } from './rceConfigUtils';
import { mapParamsToRceConfigContext } from './rceConfigMapper';
import { quizLogMsgErrorDuringTaking, quizLogMsgFailedConfigFetch, quizLogMsgInvalidParams } from './rceConfigErrorMessages';
import { handleError, setEventToQuizLog } from './rceConfigErrorHandler';
import { fetchRceConfig } from './rceConfigFetcher';
import PostMessageService from '../../../messages/postMessageService';
var decorateRcsJwtRefreshFn = function decorateRcsJwtRefreshFn(rcsJwtRefreshFn, jwt, setJwt) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(setTokenFn, questionStem) {
      var _response$json;
      var response, refreshedToken;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return rcsJwtRefreshFn(jwt);
          case 2:
            response = _context.sent;
            refreshedToken = response === null || response === void 0 || (_response$json = response.json) === null || _response$json === void 0 ? void 0 : _response$json.token; // inst-redux-service-middleware response structure
            if (refreshedToken) {
              _context.next = 7;
              break;
            }
            handleError(quizLogMsgErrorDuringTaking(questionStem));
            return _context.abrupt("return");
          case 7:
            setJwt(refreshedToken);
            setTokenFn(refreshedToken);
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var RceConfigProviderComponent = function RceConfigProviderComponent(_ref2) {
  var _activeQuiz$defaultRc;
  var activeQuiz = _ref2.activeQuiz,
    children = _ref2.children,
    contextId = _ref2.contextId,
    contextType = _ref2.contextType,
    canvasUserId = _ref2.canvasUserId,
    canvasToolId = _ref2.canvasToolId,
    rcsHost = _ref2.rcsHost,
    rcsJwt = _ref2.rcsJwt,
    rcsJwtRefreshFn = _ref2.rcsJwtRefreshFn,
    canvasOrigin = _ref2.canvasOrigin,
    storedRCEConfig = _ref2.storedRCEConfig,
    setStoredRCEConfig = _ref2.setStoredRCEConfig,
    displayOldLinks = _ref2.displayOldLinks;
  var _useState = useState(rcsJwt),
    _useState2 = _slicedToArray(_useState, 2),
    jwt = _useState2[0],
    setJwt = _useState2[1];
  var _useState3 = useState(storedRCEConfig),
    _useState4 = _slicedToArray(_useState3, 2),
    canvasConfig = _useState4[0],
    setCanvasConfig = _useState4[1];
  var rceConfigAvailable = storedRCEConfig ? false : true;
  var _useState5 = useState(rceConfigAvailable),
    _useState6 = _slicedToArray(_useState5, 2),
    canvasConfigLoading = _useState6[0],
    setCanvasConfigLoading = _useState6[1];
  var _useState7 = useState(activeQuiz === null || activeQuiz === void 0 || (_activeQuiz$defaultRc = activeQuiz.defaultRceSettings) === null || _activeQuiz$defaultRc === void 0 ? void 0 : _activeQuiz$defaultRc.toJS()),
    _useState8 = _slicedToArray(_useState7, 2),
    defaultRceSettings = _useState8[0],
    setDefaultRceSettings = _useState8[1];
  var refreshToken = rcsJwtRefreshFn && jwt ? decorateRcsJwtRefreshFn(rcsJwtRefreshFn, jwt, setJwt) : null;
  var rcsParams = {
    contextId: contextId,
    contextType: contextType,
    canvasUserId: canvasUserId,
    rcsHost: rcsHost,
    jwt: jwt,
    refreshToken: refreshToken
  };
  var ltiAppParams = {
    canvasToolId: canvasToolId
  };
  var rendererParams = {
    canvasOrigin: canvasOrigin
  };
  var flags = {
    displayOldLinks: displayOldLinks
  };
  useEffect(function () {
    ;
    _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var json;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            if (hasAllPropsForRcs(rcsParams)) {
              _context2.next = 4;
              break;
            }
            handleError(quizLogMsgInvalidParams());
            return _context2.abrupt("return");
          case 4:
            if (!storedRCEConfig) {
              _context2.next = 8;
              break;
            }
            setCanvasConfig(storedRCEConfig);
            _context2.next = 14;
            break;
          case 8:
            _context2.next = 10;
            return fetchRceConfig(rcsHost, contextType, contextId, jwt);
          case 10:
            json = _context2.sent;
            setStoredRCEConfig(json);
            setCanvasConfig(json);
            setEventToQuizLog(null);
          case 14:
            _context2.next = 20;
            break;
          case 16:
            _context2.prev = 16;
            _context2.t0 = _context2["catch"](0);
            setCanvasConfig(null);
            handleError(quizLogMsgFailedConfigFetch());
          case 20:
            _context2.prev = 20;
            setCanvasConfigLoading(false);
            return _context2.finish(20);
          case 23:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 16, 20, 23]]);
    }))();
  }, [storedRCEConfig]);
  useEffect(function () {
    var postMessageService = new PostMessageService();
    postMessageService.configurePostMessageListener();
    return function () {
      postMessageService.cleanupPostMessageListener();
    };
  }, []);
  useEffect(function () {
    var _activeQuiz$defaultRc2;
    setDefaultRceSettings(activeQuiz === null || activeQuiz === void 0 || (_activeQuiz$defaultRc2 = activeQuiz.defaultRceSettings) === null || _activeQuiz$defaultRc2 === void 0 ? void 0 : _activeQuiz$defaultRc2.toJS());
  }, [activeQuiz]);
  if (canvasConfigLoading) {
    return /*#__PURE__*/React.createElement(Card, {
      wrapped: true
    }, /*#__PURE__*/React.createElement(Spinner, null));
  }
  var defaultContextValue = _objectSpread(_objectSpread({}, mapParamsToRceConfigContext(rcsParams, rendererParams, canvasConfig, ltiAppParams, flags)), {}, {
    defaultRceSettings: defaultRceSettings
  });
  return /*#__PURE__*/React.createElement(RceConfigContext.Provider, {
    value: defaultContextValue
  }, children);
};
RceConfigProviderComponent.propTypes = {
  activeQuiz: ImmutablePropTypes.record,
  children: PropTypes.node.isRequired,
  displayOldLinks: PropTypes.bool,
  contextId: PropTypes.string,
  contextType: PropTypes.string,
  canvasUserId: PropTypes.string,
  canvasToolId: PropTypes.string,
  rcsHost: PropTypes.string,
  rcsJwt: PropTypes.string,
  rcsJwtRefreshFn: PropTypes.func,
  canvasOrigin: PropTypes.string,
  storedRCEConfig: PropTypes.shape({
    contextId: PropTypes.string,
    contextType: PropTypes.string,
    canvasOrigin: PropTypes.string,
    canvasUserId: PropTypes.string,
    canvasToolId: PropTypes.string,
    rcsHost: PropTypes.string,
    rcsJwt: PropTypes.string,
    rcsJwtRefreshFn: PropTypes.func
  }),
  setStoredRCEConfig: PropTypes.func.isRequired
};
RceConfigProviderComponent.defaultProps = {
  activeQuiz: null,
  contextId: null,
  contextType: null,
  canvasUserId: null,
  canvasToolId: null,
  rcsHost: null,
  rcsJwt: null,
  rcsJwtRefreshFn: null,
  canvasOrigin: null,
  storedRCEConfig: null,
  setStoredRCEConfig: null,
  displayOldLinks: false
};
export default RceConfigProviderComponent;